__turbopack_context__.v({
  "localContent": "VideoModal-module-scss-module__Cbs4EG__localContent",
  "modalContent": "VideoModal-module-scss-module__Cbs4EG__modalContent",
  "modalOverlay": "VideoModal-module-scss-module__Cbs4EG__modalOverlay",
  "videoFrame": "VideoModal-module-scss-module__Cbs4EG__videoFrame",
  "youtubeContent": "VideoModal-module-scss-module__Cbs4EG__youtubeContent",
});
